/**
 * The way in to feedback: a slim tab on the right edge on a wide screen, a
 * small round button bottom-right on a phone. Both open the same form.
 */
export function FeedbackTab({ onOpen }: { onOpen: () => void }) {
  return (
    <button type="button" className="feedback-tab" onClick={onOpen} aria-label="Send feedback" title="Send feedback">
      <span className="feedback-tab-label">Feedback</span>
      <span className="feedback-tab-icon" aria-hidden="true">
        💬
      </span>
    </button>
  )
}
